<!--
 * @Author: wsx
 * @Date: 2022-01-12 17:48:44
 * @LastEditTime: 2022-01-13 10:25:28
 * @LastEditors: your name
 * @Description:导入数据
-->
<template>
  <el-dialog
    v-model="formVisible"
    title="批量导入"
    width="40%"
  >
    <el-form
      label-width="120px"
    >
      <el-form-item label="第一步" >
        <h-button type="primary">下载导入模板制作Excel数据</h-button>
      </el-form-item>
      <el-form-item label="第二步" >
        <el-upload
          class="upload-Excel"
          ref="uploadRef"
          style="width:100%;"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-change="handkeChange"
          :auto-upload="false"
          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :limit="1"
        >

          <h-button type="primary" icon="icon-wenjianleixing-biaozhuntu-wenjianjia">选择文件</h-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="第三步" >
        <h-button type="primary" @click="submitUpload">开始导入</h-button>
      </el-form-item>
    </el-form>
      <el-alert
        title="提示"
        type="error"
        :closable="false"
        description="1Excel文件仅支持 Office Excel  2003及以上，WPS"
      ></el-alert>
    <template #footer>
      <!-- <h-button type="primary" @click="submitForm(ruleFormRef)">保存</h-button>
      <h-button @click="resetForm(ruleFormRef)">重置</h-button> -->
      <h-button @click="formVisible = false">取消</h-button>
    </template>
  </el-dialog>
</template>
<script >
import {
  defineComponent,
  reactive,
  watchEffect,
  toRefs,
  ref
} from 'vue';
export default defineComponent({
  name: 'importDialog',
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(props, context) {
    const state = reactive({
      formVisible: false
    });
    const uploadRef = ref(null);
    const refData = toRefs(state);
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit('update:modelValue', state.formVisible);
    });

    const handleRemove = (file, fileList) => {
      console.log(file, fileList);
    };
    const handlePreview = (file) => {
      console.log(file);
    };
    const handkeChange = (file, fileList) => {
      console.log('%c [ file, fileList ]-93', 'font-size:13px; background:pink; color:#bf2c9f;', file, fileList);
    };
    const submitUpload = () => {
      uploadRef.value.submit();
    };
    return {
      ...refData,
      handleRemove,
      uploadRef,
      handkeChange,
      submitUpload,
      handlePreview
    };
  }
});
</script>
<style  lang='scss' scoped >
.importDialog {
  .upload-Excel{
    width: 100%;
  }
}
</style>